<template>
    <div>
        <main role="main" class="background-employer-dashboard background-employer-dashboard-bottom pb-5">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-white">
                        <li class="breadcrumb-item color-blue" aria-current="page">{{ Lang.get('employerdashboard::pages/notifications/index.title') }}</li>
                    </ol>
                </nav>
                <h1 class="font-poppins font-weight-extra-light color-blue mt-4">{{ Lang.get('employerdashboard::pages/notifications/index.title') }}</h1>
                <h6 class="font-poppins font-weight-light font-size-18 color-blue">{{ Lang.get('employerdashboard::pages/notifications/index.subtitle') }}</h6>
                <div class="row mt-5">
                    <div class="col-12 col-md-8 mb-4">
                        <div class="card h-100 border-radius-8 shadow">
                            <div class="card-body px-0 py-2">
                                <ul class="nav nav-tabs px-3" id="employeeTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active font-poppins font-size-14 color-blue" id="all-tab" data-toggle="tab" href="#all" role="tab" aria-controls="home" aria-selected="true">
                                            {{ Lang.get('employerdashboard::pages/notifications/index.tabs.all.title') }}
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content" id="notificationTabContent">
                                    <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
                                        <div id="notificationAccordion">
                                            <div class="card border-0">
                                                <div class="card-header px-4 py-3 bg-white cursor-pointer collapsed" id="heading_1" data-toggle="collapse" data-target="#collapse_1" aria-expanded="false" aria-controls="collapse_1">
                                                <span class="font-poppins font-weight-light font-size-18 color-blue">
                                                    <input type="checkbox" class="mr-1"> TITEL
                                                </span>
                                                </div>

                                                <div id="collapse_1" class="collapse" aria-labelledby="heading_1" data-parent="#notificationAccordion">
                                                    <div class="card-body border-bottom font-poppins font-weight-light color-dark-blue pt-0 px-4">
                                                        Inhoud van bericht
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card border-0">
                                                <div class="card-header px-4 py-3 bg-white cursor-pointer collapsed" id="heading_2" data-toggle="collapse" data-target="#collapse_2" aria-expanded="false" aria-controls="collapse_1">
                                                <span class="font-poppins font-weight-light font-size-18 color-blue">
                                                    <input type="checkbox" class="mr-1"> Titel op tweede regel
                                                </span>
                                                </div>

                                                <div id="collapse_2" class="collapse" aria-labelledby="heading_2" data-parent="#notificationAccordion">
                                                    <div class="card-body border-bottom font-poppins font-weight-light color-dark-blue pt-0 px-4">
                                                        Inhoud van tweede bericht
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/Search'

export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/notifications/index.title') },
    layout: Layout,
    components: {
        Pagination,
        SearchFilter,
    },
    props: {
        company: Object,
    },
}
</script>
